import { PaymentMode } from "src/models/InstallmentPayment.model";

export const paymentModeOptions: {
  label: string;
  value: keyof typeof PaymentMode;
}[] = [
  {
    label: "Cash",
    value: "CASH",
  },
  {
    label: "Net Banking",
    value: "BANK_TRANSFER",
  },
  {
    label: "UPI",
    value: "UPI",
  },
  {
    label: "Cheque",
    value: "CHEQUE",
  },
  {
    label: "Other",
    value: "OTHER",
  },
];
